import React, { useRef } from 'react';
import { createPortal } from 'react-dom';
import { useGameDialogAccessibility } from './GameDialog';

/** Preserve the printed board's inspector while keeping it outside camera transforms. */
export function ClassicLocationDialog({ title, onClose, children }: {
  title: string; onClose: () => void; children: React.ReactNode;
}) {
  const ref = useRef<HTMLDivElement>(null);
  useGameDialogAccessibility(true, true, ref, undefined, onClose);
  return createPortal(<div className="game-ui game-dialog-backdrop location-full-overlay" onClick={onClose}>
    <div ref={ref} className="game-detail-dialog location-detail-panel" role="dialog" aria-modal="true" aria-label={title}
      onClick={event => event.stopPropagation()}>
      <button type="button" className="game-dialog-close location-detail-close" aria-label="Close location details" onClick={onClose}>×</button>
      {children}
    </div>
  </div>, document.body);
}
